export default "__VITE_ASSET__Bh_2A8Q___"